/**
 * Step 1: Reset Login-Data
 */
window.resetLoginData = function() {
  $('#login-id, #login-username, #login-password, #saved-logins').val('');
  $('#login-username').focus();
};

/**
 * Step 1: weiter zu Logindaten eingeben
 * @param basePath
 * @param id
 * @returns {boolean}
 */
window.createEditLoginData = function(basePath, id = 0) {
  if (id > 0) {
    window.location = basePath + '?step=2&login=' + id;
  } else {
    window.location = basePath + '?step=2&login=';
  }
};

/**
 * Step 1: Logindaten ein/ausblenden
 * @param id
 */
window.toggleHideLoginData = function(id){
  $.ajax({
    url: BASE_PATH + 'ajax/helper/betriebsdaten/ajax.hideLoginData',
    type: 'post',
    data: {
      id: id,
    },
    success: function() {
      const currentVal = document.getElementById('showAll').checked;
      ListLoginData.updater({showAll: currentVal});
    }
  });
}

/**
 * Step 1: Shop Import Picture
 * @param element
 */
window.showImportPicture = function(element) {
  const verbandPictures = $('.verband-picture');
  const verbandID = Number($(element).val());
  const verbandRow = $('#verband-' + verbandID);

  verbandPictures.addClass('display-none');
  if (verbandRow.length > 0) {
    verbandRow.removeClass('display-none');
  }
};

/**
 * showAuthentication
 * @param element
 */
window.showAuthentication = function(element) {
  // Verband-ID
  const verbandID = Number(element.value);

  // VOG
  document.querySelectorAll('.show-vog-only').forEach((element) => {
    if (verbandID === 5) {
      element.classList.remove('display-none');
    } else {
      element.classList.add('display-none');
    }
  });
  // VOG
  document.querySelectorAll('.hide-vog').forEach((element) => {
    if (verbandID === 5) {
      element.classList.add('display-none');
    } else {
      element.classList.remove('display-none');
    }
  });

  // Enogis
  document.querySelectorAll('.show-enogis').forEach((element) => {
    if (verbandID === 17) {
      element.classList.remove('display-none');
    } else {
      element.classList.add('display-none');
    }
  });
};

/**
 * selectRow
 * @param row
 */
window.selectRow = function(row) {
  if ($(event.target).hasClass('material-icons')) {
    return;
  }
  const hasNewClass = $(row).hasClass('new');
  const isSelected = $(row).hasClass('selected');
  const importTable = $(row).closest('.row-table');
  let isSwitching = (!isSelected && hasNewClass);

  // reset classes
  $('.betriebeimport-zusammenfuehren').find('.row-table').removeClass('has-selected').find('.importRow').removeClass('not-selected').removeClass('selected');

  // add new active
  if (isSwitching) {
    importTable.addClass('has-selected');
    importTable.find('.importRow').addClass('not-selected');
    $(row).removeClass('not-selected').addClass('selected');
  }
};

/**
 * mergeSections
 * @param row
 * @param basePath
 * @param isDifferentAnlage
 */
window.mergeSections = function(row, basePath, isDifferentAnlage = false) {
  if ($(event.target).hasClass('material-icons')) {
    return;
  }

  const abschnittID = $(row).data('abschnittId');
  const anlageCodeDb = $(row).data('anlageCode');
  const dataDb = $(row).data();

  const dataDbList = {};
  for (const dataDbKey in dataDb) {
    if (dataDb.hasOwnProperty(dataDbKey)) {
      dataDbList[dataDbKey] = dataDb[dataDbKey];
    }
  }

  const selectedRowImport = $('.selected');
  const dataImport = selectedRowImport.data();

  const dataImportList = {};
  for (const dataImportKey in dataImport) {
    if (dataImport.hasOwnProperty(dataImportKey)) {
      dataImportList[dataImportKey] = dataImport[dataImportKey];
    }
  }

  const anlageCodeImport = selectedRowImport.data('anlageCode');
  if (anlageCodeDb === anlageCodeImport || isDifferentAnlage) {
    ajaxDialog(basePath + 'ajax/dialog/betriebsdaten/ajax.confirmAbschnitteZusammenfuehren?abschnittID=' + abschnittID, 450, {
      post_data: {
        dataDb: dataDbList,
        dataImport: dataImportList,
      },
    });
  } else {
    ajaxDialog(basePath + 'ajax/dialog/betriebsdaten/ajax.importInfoKeinZusammenfuehren', 450);
  }
};

/**
 * undoMerge
 * @param abschnittCode
 * @param isNewAnlage
 */
window.undoMerge = function(abschnittCode, isNewAnlage = false) {
  const row = $('#import-' + abschnittCode);
  const input = row.find('.importSection');
  const heftID = input.val();
  const rowResetClasses = row.data('reset-classes').trim();
  const anlageCode = row.data('anlageCode');

  row.addClass(rowResetClasses).removeClass('selected').removeClass('migrated').find('.hinweis').show();
  row.find('.undo').hide();
  $(input).val('new');
  $('[data-abschnitt-id="' + heftID + '"]').removeClass('hide-row');
  $('.hide-anlage-' + anlageCode).show();
  $('.select-plant-' + anlageCode).show();
  $('#deleteSection-' + heftID).val(1);
  if (!isNewAnlage) {
    $('#forwardButton').attr('disabled', true);
  }
};

/**
 * openDialog
 * @param abschnittCodeImport
 * @param abschnittIDDb
 * @param basePath
 */
window.openDialog = function(abschnittCodeImport, abschnittIDDb, basePath) {
  const importRow = $('#import-' + abschnittCodeImport).data();
  const heftRow = $('#abschnitt-' + abschnittIDDb).data();

  const dataDbList = {};
  for (const heftRowKey in heftRow) {
    if (heftRow.hasOwnProperty(heftRowKey)) {
      dataDbList[heftRowKey] = heftRow[heftRowKey];
    }
  }

  const dataImportList = {};
  for (const importRowKey in importRow) {
    if (importRow.hasOwnProperty(importRowKey)) {
      dataImportList[importRowKey] = importRow[importRowKey];
    }
  }
  ajaxDialog(basePath + 'ajax/dialog/betriebsdaten/ajax.contentImportAbweichung', 900, {
    post_data: {
      dataDb: dataDbList,
      dataImport: dataImportList,
    },
  });
};

/**
 * setMerge
 * @param abschnittID
 */
window.setMerge = function(abschnittID) {
  const selectedMigrateRow = $('[data-abschnitt-id="' + abschnittID + '"]');
  const anlageCode = selectedMigrateRow.data('anlageCode');
  const migrateTable = selectedMigrateRow.closest('.row-table');
  const importTable = migrateTable.prevAll('.row-table');
  const selectedRowImport = importTable.find('.selected');

  selectedMigrateRow.addClass('hide-row').removeClass('diff');

  selectedRowImport.find('.importSection').val(abschnittID);
  selectedRowImport.find('.undo').show();

  importTable.removeClass('has-selected');
  importTable.find('.importRow').removeClass('not-selected');
  selectedRowImport.removeClass('selected').removeClass('new').removeClass('diff').addClass('migrated');
  $('#deleteSection-' + abschnittID).val(0);

  updateForwardButton();

  hideAnlageHeft(anlageCode);
};

/**
 * setDelete
 * @param deleteID
 * @param isFactory
 */
window.setDelete = function(deleteID, isFactory) {
  if (isFactory == null) {
    const row = $('#abschnitt-' + deleteID);
    row.addClass('hide-row').removeClass('diff');
    $('#deleteSection-' + deleteID).val('1');
    updateForwardButton();
    const anlageCode = row.data('anlageCode');
    hideAnlageHeft(anlageCode);
  } else {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/betriebsdaten/ajax.deleteBetrieb',
      type: 'post',
      data: {
        type: 'auth',
        factoryID: deleteID,
      },
      success: function() {
        $.ajax({
          url: BASE_PATH + 'ajax/helper/betriebsdaten/ajax.checkImportCorrectRecords',
          type: 'post',
          dataType: 'json',
          beforeSend: function() {
            insertAutoLoader($('#table-importBetriebe'));
          },
          success: function() {
            window.location.reload();
          },
        });
      },
    });
  }
};

/**
 * Anlagen aus Heft ausblenden
 * @param anlageCode
 */
window.hideAnlageHeft = function(anlageCode) {
  // Heft ausblenden, falls keine offenen Abschnitte mehr vorhanden
  const heftRowTable = $('.row-table.hide-anlage-' + anlageCode);
  let countHideRows = 0;
  heftRowTable.find('.row').each(function(key, item) {
    if ($(item).hasClass('hide-row')) {
      countHideRows++;
    }
  });

  // countHideRows + 1, weil Zeile mit Überschrift auch dabei
  if (countHideRows + 1 === heftRowTable.find('.row').length) {
    $('.hide-anlage-' + anlageCode).hide();
    $('.select-plant-' + anlageCode).hide();
  }
};

/**
 *
 * @param betriebsleiterNr
 * @param isImport
 */
window.authenticateVOG = function(betriebsleiterNr, isImport = true) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/betriebsdaten/ajax.authenticateVOG',
    type: 'post',
    data: {
      type: 'auth',
      betriebsleiterNr: betriebsleiterNr,
      isImport: isImport,
    },
    success: function(response) {
      window.location.href = response;
    },
  });
};

/**
 * prüft, ob nächster Step möglich ist
 */
window.updateForwardButton = function() {
  if ($('.diff').not('.migrated').length === 0) {
    $('#forwardButton').removeAttr('disabled');
  }
};

/**
 * getPlantData
 * @param anlageCode
 * @param value
 * @param basePath
 */
window.getPlantData = function(anlageCode, value, basePath) {
  // falls bereits etwas ausgewählt und zusammengeführt war, muss das wieder rückgängig gemacht werden
  $('.importRow[data-anlage-code="' + anlageCode + '"]').each(function() {
    undoMerge($(this).data('abschnittCode'), true);
  });

  // wenn eine Anlage ausgewählt wurde, müssen deren Daten+Abschnitte geladen werden
  $.ajax({
    url: basePath + 'ajax/helper/betriebsdaten/ajax.getPlantImport',
    type: 'post',
    dataType: 'json',
    data: {
      plantID: value,
      anlageCode: anlageCode,
    },
    success: function(response) {
      if (response['success'] === true) {
        $('#anlage-' + anlageCode).html(response['data']);
        $('h3.hide-anlage-' + anlageCode).html(response['anlageName']);
        $('div.betriebeimport-zusammenfuehren').each(function() {
          const current = $(this);
          if (String(current.data('anlageHeft')) === String(value)) {
            // wenn es nicht die Anlage aus dem Import ist muss ausgeblendet werden
            if (current.find('#anlage-' + anlageCode).length === 0) {
              current.hide();
            }
          } else {
            current.show();
          }
        });

      } else {
        $('div.betriebeimport-zusammenfuehren').each(function() {
          $(this).show();
        });
      }
    },
  });
  if (value !== 'new') {
    $('.hide-anlage-' + anlageCode).show();
  } else {
    $('.hide-anlage-' + anlageCode).hide();
  }
};